export const normalizeString = (stringToNormalize) => {
    const result = stringToNormalize.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    return result.replace(/[^a-zA-Z0-9]+/ig, '-').toLowerCase();
};

